import React, { useState, useEffect } from "react";
import { 
  Box, 
  useColorModeValue, 
  Flex, 
  Text, 
  HStack, 
  Icon, 
  SimpleGrid,
  Heading
} from '@chakra-ui/react';
import { MdLocationOn } from "react-icons/md";
import axios from 'axios';

const FacilityList = () => {
  const [value, setValue] = useState("1");

  const locations = [
    { id: "1", name: "Chicago" },
    { id: "2", name: "Reston" }
    // Add more locations as needed
  ];

  const bg = useColorModeValue("white", "gray.800");
  const selectedBg = useColorModeValue("rgba(130, 202, 156, 0.1)", "rgba(130, 202, 156, 0.2)");

  const [location, setLocation] = useState([]);
  const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:3001' ;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/facility`, {
          params: {
            location_id: value
          },
          withCredentials: true,
        })

        setLocation(response.data.message);
        console.log('Location:', location)
      } catch (error) {
        console.error('Error:', error);
      }
    };
    fetchData();
  }, [value]); // Add value as a dependency

  return (
    <Box 
      borderRadius="lg"
      p={4}
      bg="white"
      mb={6}
    >
      <HStack marginBottom={4}>
        <Icon as={MdLocationOn} color="#82ca9c" boxSize={5} />
        <Text fontWeight="600">Select a facility</Text>
      </HStack>
      
      <Box 
        borderRadius="md" 
        py={3} 
        px={2}
      >
        <SimpleGrid 
          columns={{ base: 1, sm: 2 }} 
          spacing={4}
        >
          {locations.map((loc) => (
            <Box 
              key={loc.id} 
              p={4}
              bg={value === loc.id ? "rgba(130, 202, 156, 0.1)" : "white"}
              borderRadius="lg"
              border="1px solid"
              borderColor={value === loc.id ? "#82ca9c" : "#e2e8f0"}
              cursor="pointer"
              transition="all 0.2s"
              onClick={() => setValue(loc.id)}
              textAlign="center"
              boxShadow={value === loc.id 
                ? "0 4px 12px rgba(130, 202, 156, 0.2)" 
                : "0 2px 6px rgba(0, 0, 0, 0.05)"
              }
              _hover={{
                borderColor: "#82ca9c",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.08)"
              }}
            >
              <Text 
                fontWeight={value === loc.id ? "bold" : "medium"}
                color={value === loc.id ? "#82ca9c" : "gray.700"}
                fontSize="md"
              >
                {loc.name}
              </Text>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default FacilityList;